import { HTMLProps } from "react";
import Toggle from "@/components/common/Toggle";
import { useAppStore } from "@/store/app";
import { ControlsStatGroupType } from "@/utils/types";
import { cn } from "@/utils/helpers";
import { getControlStats, getLang } from "@/utils/selectors";
import styles from "../Controls.module.css";

export interface ControlsStatsToggleProps extends HTMLProps<HTMLElement> {
	group: ControlsStatGroupType;
	subGroup?: string;
	onChange: (value: any) => void;
};

export default function ControlsStatsToggle({
	group,
	subGroup,
	onChange
} : ControlsStatsToggleProps) {
	const controls = useAppStore(store => store.controls);
	
	return (
		<Toggle
			type={controls.view}
			value={controls.stat}
			label={getLang("stat", group, subGroup)}
			options={getControlStats(controls.view, group, subGroup)}
			tooltipLangParams={{
				geo: getLang("geo", controls.geo).toLocaleLowerCase()
			}}
			ButtonProps={{
				filled: true,
				color: "secondary"
			}}
			TooltipProps={{
				footer: getLang("stat", "tooltip", "footer"),
			}}
			onToggleChange={onChange}
			className={cn(
				styles.ControlsStatsToggle,
				styles[`ControlsStatsToggle_${group}`]
			)}
		/>
	)
}